export default __webpack_public_path__ + "static/media/hero.49ec5e82.png";